import { Component, Input, OnInit } from '@angular/core';
import { tableData } from './table-data';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DataService } from 'src/app/shared/services/data.service';
import { environment } from 'src/environments/environment';
import { AllGradesFilterType } from 'src/app/models/enums/allgradesFilterType';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime } from 'rxjs';

@Component({
  selector: 'app-all-grades',
  templateUrl: './all-grades.component.html',
  styleUrls: ['./all-grades.component.scss', './all-grades.component.en.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.2s')),
    ]),
  ],
})
export class AllGradesComponent implements OnInit {
  displayedColumns: string[] = ['assignmentText', 'teacher', 'points', 'rating', 'actions'];
  // expandedColumns: string[] = ['expandedAssignmentText', 'expandedPoints', 'expandedRating', 'expandedActions'];
  expandedColumns: string[] = ['expandedAssignmentText'];
  expandedElement: any | null;
  expandedSubElement: any | null;

  @Input({ required: true }) data: any;
  @Input({ required: true }) generalSettings: any;
  finalGradesData: any;
  filtersData: any;
  selectedFilterData: any = {
    activityDegreesStatusListFilter: null,
    degreesFilter: null,
    semesterListFilter: null,
    sortTypeListFilter: null,
    term: ''
  };
  term: string = '';
  termObj = new Subject<string>();
  isMainDataLoaded: boolean = false;
  isLoading: boolean = false;
  urlParamsBaseName = "all_final_grades_";
  isServerError: boolean = false;

  constructor(private dataService: DataService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.termObj.pipe(debounceTime(1000)).subscribe((term) => {
      this.selectedFilterData.term = term;
      this.getData();
    });

    this.getUrlParameters();
    this.getIndexData();
  }

  private getIndexData() {
    this.isLoading = true;
    var url = environment.apiUrl + '/Portal/StudentAllGradesDetailedListViewBlockList/Index';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      activityStatusKey: this.selectedFilterData.activityDegreesStatusListFilter,
      studentDegree: this.selectedFilterData.degreesFilter,
      yearAndSemester: this.selectedFilterData.semesterListFilter,
      term: this.selectedFilterData.term,
      sortBy: this.selectedFilterData.sortTypeListFilter,
      courseGradeAverageText: this.data.courseGradeAverageText
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {    
        //console.log(responseData); //TODO: dont forget to remove

        responseData.activityDegreesStatusListFilter = this.addDefaultOptionToFilters(responseData.activityDegreesStatusListFilter, 
          this.data.allDegreesStatusDefaultOption, this.selectedFilterData.activityDegreesStatusListFilter);
        responseData.degreesFilter = this.addDefaultOptionToFilters(responseData.degreesFilter, 
          this.data.allDegreesDefaultOption, this.selectedFilterData.degreesFilter);
        responseData.semesterListFilter = this.addDefaultOptionToFilters(responseData.semesterListFilter, 
          this.data.allSemesterDefaultOption, this.selectedFilterData.semesterListFilter);

        this.filtersData = {
          activityDegreesStatusListFilter: responseData.activityDegreesStatusListFilter,
          degreesFilter: responseData.degreesFilter,
          semesterListFilter: responseData.semesterListFilter,
          sortTypeListFilter: responseData.sortTypeListFilter,
        };
        
        this.selectedFilterData.activityDegreesStatusListFilter = this.filtersData.activityDegreesStatusListFilter 
          ? this.filtersData.activityDegreesStatusListFilter.filter((x: any) => x.checked)[0].value : null;
        this.selectedFilterData.degreesFilter = this.filtersData.degreesFilter ? this.filtersData.degreesFilter.filter((x: any) => x.checked)[0].value : null;
        this.selectedFilterData.semesterListFilter = this.filtersData.semesterListFilter ? this.filtersData.semesterListFilter.filter((x: any) => x.checked)[0].value : null;
        this.selectedFilterData.sortTypeListFilter = this.filtersData.sortTypeListFilter ? this.filtersData.sortTypeListFilter.filter((x: any) => x.checked)[0].value : null;

        if(this.selectedFilterData.term) {
          this.term = this.selectedFilterData.term;
        }

        this.finalGradesData = responseData.departmentGradesList;
        this.isMainDataLoaded = true;
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.isServerError = true;
      },
    });
  }

  addDefaultOptionToFilters(filters: any, defaultOption: string, selectedValue: string): any {
    if (filters && filters.length > 0 && defaultOption) {
      let defaultChecked = selectedValue ? false : true;
      filters.push({ value: '-1', label: defaultOption, checked: defaultChecked });
      if(!defaultChecked) {
        let index = filters.findIndex((c: any) => c.value == selectedValue);
        if(index != -1) filters[index].checked = true;
      }
    }
    return filters;
  }

  getRowColor(type: StudentDataType) {
    if(type == StudentDataType.Exam || type == StudentDataType.Quiz) return '#F90';
    return '#BA73E5';
  }

  getDepartmentName(name: string): string {
    if(this.data.departmentNameTitle) {
      if(this.data.departmentNameTitle.includes('{0}')) {
        return this.data.departmentNameTitle.replace('{0}', name);
      }
      return this.data.departmentNameTitle + ' ' + name;
    }
    return name;
  }

  getTotalDepartmentTitle(name: string): string {
    if(this.data.totalDepartmentTitle) {
      if(this.data.totalDepartmentTitle.includes('{0}')) {
        return this.data.totalDepartmentTitle.replace('{0}', name);
      }
      return this.data.totalDepartmentTitle + ' ' + name;
    }
    return name;
  }

  private getData() {
    if(this.isLoading) return;
    this.updateUrlParameters();
    var url = environment.apiUrl + '/Portal/StudentAllGradesDetailedListViewBlockList/SearchGrades';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      activityStatusKey: this.selectedFilterData.activityDegreesStatusListFilter,
      studentDegree: this.selectedFilterData.degreesFilter,
      yearAndSemester: this.selectedFilterData.semesterListFilter,
      term: this.selectedFilterData.term,
      sortBy: this.selectedFilterData.sortTypeListFilter,
      courseGradeAverageText: this.data.courseGradeAverageText
    };
    this.isLoading = true;
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.finalGradesData = responseData.departmentGradesList;
        this.isLoading = false;
      },
      error: (e) => {
        console.error(e);
        this.isLoading = false;
        this.isServerError = true;
      },
    });
  }

  onKeySearch(event: any) {
    this.termObj.next(event);
  }

  searchGrades(event: { filterData: any, allGradesFilterType: AllGradesFilterType }) {
    //console.log(event); //TODO: dont forget to remove
    switch (event.allGradesFilterType) {
      case AllGradesFilterType.ActivityDegreesStatusFilter:
        this.selectedFilterData.activityDegreesStatusListFilter = event.filterData.filter((x: any) => x.checked)[0].value;
        break;
      case AllGradesFilterType.DegreesFilter:
        this.selectedFilterData.degreesFilter = event.filterData.filter((x: any) => x.checked)[0].value;
        break;
      case AllGradesFilterType.SemesterListFilter:
        this.selectedFilterData.semesterListFilter = event.filterData.filter((x: any) => x.checked)[0].value;
        break;
      case AllGradesFilterType.SortTypeListFilter:
        this.selectedFilterData.sortTypeListFilter = event.filterData.filter((x: any) => x.checked)[0].value;
        break;
    }
    this.getData();
  }

  private getUrlParameters() {  
    this.route.queryParams.subscribe(params => {
      this.selectedFilterData.activityDegreesStatusListFilter = params[this.urlParamsBaseName + "activityDegreesStatusFilter"] || null;
      this.selectedFilterData.degreesFilter = params[this.urlParamsBaseName + "degreesFilter"] || null;
      this.selectedFilterData.semesterListFilter = params[this.urlParamsBaseName + "semesterFilter"] || null;
      this.selectedFilterData.sortTypeListFilter = params[this.urlParamsBaseName + "sortTypeFilter"] || null;
      this.selectedFilterData.term = params[this.urlParamsBaseName + "term"] || null;
    });
  }

  private updateUrlParameters() {
    if(!this.selectedFilterData) return;

    var searchParams = new URL(window.location.href).searchParams;
    let queryParams: any = {};

    searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    if(this.selectedFilterData.activityDegreesStatusListFilter && this.selectedFilterData.activityDegreesStatusListFilter !== '-1')
      queryParams[this.urlParamsBaseName + "activityDegreesStatusFilter"] = this.selectedFilterData.activityDegreesStatusListFilter;
    else
      delete queryParams[this.urlParamsBaseName + "activityDegreesStatusFilter"];

    if(this.selectedFilterData.degreesFilter && this.selectedFilterData.degreesFilter !== '-1')
      queryParams[this.urlParamsBaseName + "degreesFilter"] = this.selectedFilterData.degreesFilter;
    else
      delete queryParams[this.urlParamsBaseName + "degreesFilter"];

    if(this.selectedFilterData.semesterListFilter && this.selectedFilterData.semesterListFilter !== '-1')
      queryParams[this.urlParamsBaseName + "semesterFilter"] = this.selectedFilterData.semesterListFilter;
    else
      delete queryParams[this.urlParamsBaseName + "semesterFilter"];

    if(this.selectedFilterData.sortTypeListFilter && this.selectedFilterData.sortTypeListFilter !== '-1')
      queryParams[this.urlParamsBaseName + "sortTypeFilter"] = this.selectedFilterData.sortTypeListFilter;
    else
      delete queryParams[this.urlParamsBaseName + "sortTypeFilter"];

    if(this.selectedFilterData.term && this.selectedFilterData.term !== '')
      queryParams[this.urlParamsBaseName + "term"] = this.selectedFilterData.term;
    else
      delete queryParams[this.urlParamsBaseName + "term"];

    queryParams = Object.keys(queryParams).length > 0 ? queryParams : null;

    var url = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: queryParams,
        //queryParamsHandling: 'merge'
      }).toString();

    window.history.pushState({ path: url }, '', url);
  }

  getFilteredStudentDataTypes(dataType:any): any[] {
    return this.dataService.generalSettingsData.studentDataTypeItems.filter(
       (item:any) => item.studentDataTypeItemData.key == dataType
     );
   }
}
